import store from '@player/src/store';
import AnimationModel from '@src/slide/domain/ui-model/element-modeles/anim-model';
import { IAnimModel } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import { AnimType } from '@tencent/slide-sdk-model';
import _isArray from 'lodash/isArray';
import { PLAY_MODE } from './constants';

// 获取幻灯片宽高
export function getSlideWH() {
    const states = store.getState();
    const slideWidth = (states.control as any).clientWidth || 0;
    const slideHeight = (states.control as any).clientHeight || 0;
    return { slideWidth, slideHeight };
}

// 获取 presetClass
export const getAnimClassByPlayMode = (timeNode, playMode) => {
    if (playMode === PLAY_MODE.play) {
        return timeNode?.anim?.presetClass;
    }

    return timeNode?.props?.presetClass;
};

// 获取 animType
export const getAnimTypeByPlayMode = (timeNode, playMode) => {
    if (playMode === PLAY_MODE.play) {
        return timeNode.supportAnimType;
    }
    return timeNode.props.animType;
};

// 获取动画方向
export const getAnimDirection = (timeNode, playMode) => {
    if (playMode === PLAY_MODE.play) {
        return timeNode.anim.presetSubtype;
    }
    return timeNode.props.subType;
};

// 获取动画延时
export const getAnimDuration = (timeNode, playMode) => {
    if (playMode === PLAY_MODE.play) {
        return timeNode.dur;
    }
    return timeNode.props.duration;
};


// 获取幻灯片宽高
export const getSlideWidthAndHeight = (timeNode, playMode) => {
    if (playMode === PLAY_MODE.play) {
        return getSlideWH();
    }
    const presentationProps = timeNode?.parent?.parent?.props;
    return {
        slideWidth: presentationProps?.slideWidth || 0,
        slideHeight: presentationProps?.slideHeight || 0,
    };
};

export const getTnRotate = timeNode => timeNode?.elementModel?.props?.style?.rotate || 0;

/**
 * 传入的是否为预期类型
 */
export const isRightAnimType = (
    timeNode: AnimationModel | IAnimModel,
    playMode: PLAY_MODE,
    animType: AnimType | AnimType[],
) => {
    const curType = getAnimTypeByPlayMode(timeNode, playMode);
    if (_isArray(animType)) {
        return animType.includes(curType);
    }
    return curType === animType;
};
